'use strict';

import {DOM} from	'../helpers/DOM.js';


export class CopyText {
	#inputElement;
	constructor() {
		DOM.addEvent('click', '[data-lev-copy="true"]' , (event, select) => {
			 this.#inputElement = select.querySelector('input[type="hidden"]');
			this.#copyTextToClipboard(this.#inputElement.value);
			this.#showCopyMessage();
		})
	}


	#copyTextToClipboard(text) {
		const tempTextArea = document.createElement('textarea');
		tempTextArea.value = text;
		document.body.appendChild(tempTextArea);
		tempTextArea.select();
		document.execCommand('copy');
		document.body.removeChild(tempTextArea);
	}


	#showCopyMessage() {
		const messageElement = document.createElement('div');
		messageElement.textContent = 'Shortcode copied';
		messageElement.style.cssText = `
        position: fixed;
        top: 100px;
    	right: 0;
        transform: translateX(-50%);
        padding: 10px;
        background-color: #4CAF50;
        color: white;
        font-weight: bold;
        border-radius: 5px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        z-index: 9999;
    `;

		document.body.appendChild(messageElement);

		setTimeout(() => {
			document.body.removeChild(messageElement);
		}, 3000);
	}
}
